import { createMuiTheme } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: 'Roboto',
    fontSize: 14
  },
  palette: {
    primary: {
      main: '#d4b831',
      contrastText: '#fff',
    },
    secondary: {
      main: "#ededed",
      contrastText: "#111"
    },
    danger: {
      main: red[500],
      light: red[100]
    },
    text: {
      primary: "#2b2b2b",
      secondary: "#ededed"
    },
    divider: "rgba(200,200,200, 0.25)"
  },
});

export default theme;